/* eslint-disable */
<template>
  <div class="specialist-ava-menu sub-menu">
    <ul>
      <li><router-link to="/specialist-progress-bookings">Work in Progress</router-link></li>
      <li><router-link to="/specialist-court-cases">Court Cases and Teleconferences</router-link></li>
      <li><router-link to="/specialist-appointments">Upcoming Appointments</router-link></li>
      <li><router-link to="/specialist-finished">Finished Bookings</router-link></li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'SpecialistBookingMenu',
  props: ["indexProps"],
  data() {
    return {

    }
  },
  methods: {

  },
  beforeMount() {
    if(this.indexProps == undefined) {
      this.indexProps = 0
    }
  },
  mounted() {
    $(".sub-menu li").eq(this.indexProps).addClass("sub-menu-selected")
  },
}
</script>
